var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"cover-back-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Задник_Контур"}},[_c('path',{staticClass:"bc-c-3",attrs:{"d":"M467.62,269.65V129.33H46.38V269.65a15,15,0,0,0,15,15H452.62A15,15,0,0,0,467.62,269.65Z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }